import Cookies from 'js-cookie'

import config from '@/config'

import { REFERRAL_SOURCE_BLANK } from '@/constants'

export interface ExtraCookieData {
    referralSource: string | undefined
    variant: string | undefined
    marketingData: {
        utmCampaign: string | undefined
        utmContent: string | undefined
        utmMedium: string | undefined
        utmSource: string | undefined
        utmTerm: string | undefined
    }
}

export const clearExtraProfileCookieData = () => {
    const COOKIES = ['referralSource', 'utmCampaign', 'utmContent', 'utmMedium', 'utmSource', 'utmTerm', 'variant']
    COOKIES.forEach((cookie) => {
        Cookies.remove(cookie, {
            path: '/',
            domain: config.cookieDomain,
            secure: true,
        })
    })
}

export const getExtraProfileCookieData = () => {
    const extraCookieData: ExtraCookieData = {
        referralSource: Cookies.get('referralSource') ?? REFERRAL_SOURCE_BLANK,
        variant: Cookies.get('variant'),
        marketingData: {
            utmCampaign: Cookies.get('utmCampaign'),
            utmContent: Cookies.get('utmContent'),
            utmMedium: Cookies.get('utmMedium'),
            utmSource: Cookies.get('utmSource'),
            utmTerm: Cookies.get('utmTerm'),
        },
    }

    return extraCookieData
}
